import axiosInstance from '@/service/helpers/axios'
export async function getProfile() {
  const result = await axiosInstance.get('/internal-user/profile')
  return result
}
export async function updateProfile(profile: {
  fullname: string | undefined
  alamat: string | undefined
  gender: string | undefined
  // phone: string | undefined
}) {
  const result = await axiosInstance.post('/internal-user/update-profile', profile)
  return result
}
export async function updatePassword(passwordDetail: {
  currentPassword: string
  newPassword: string
  // phone: string | undefined
}) {
  const result = await axiosInstance.post('/internal-user/change-password', passwordDetail)
  return result
}

export async function updateProfileThumbnail(body: { thumbnail: null | Dropzone.DropzoneFile }) {
  const result = await axiosInstance.post(`/content-contributor/update-thumbnail`, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result
}
